module.exports = __webpack_public_path__ + "static/media/arrest.3d1e6512.svg";